import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

type P = {
  bShow: boolean;
  title: string;
  description: string;
  titleButtonApply: string;
  titleButtonCancel: string;
  onApply: () => void;
  onCancel: () => void;
};

export const ConfirmDialog = (p: P) => {
  return (
    <Dialog
      open={p.bShow}
      onClose={p.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{p.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {p.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={p.onApply}>{p.titleButtonApply}</Button>
        <Button onClick={p.onCancel} autoFocus>
          {p.titleButtonCancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
